import css from "./Carrossel.module.css"
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import {Navigation, Pagination, Scrollbar, A11y, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


function Carrossel() {
    const navigate = useNavigate();
    return (
        <div className={`${css.containerCarrossel} d-flex flex-column justify-content-center p-2`}>
            <p className={`px-5 pt-3 ${css.sobre}`} >SOBRE NÓS</p>
            <div className={`${css.divsCarrossel} gap-lg-5 gap-3 pb-3`}>
                <div className={`${css.carrosselIn} d-flex  justify-content-center align-items-center p-3`}>
                    <p className={" text-justify"}>A Clínica NeuroAudio é especializada no cuidado da audição, do labirinto e da comunicação; com uma abordagem que integra audiologia e neurociência. Nosso compromisso é oferecer avaliações precisas e tratamentos personalizados, respeitando as necessidades individuais de cada paciente em todas as fases da vida.

                        Atuamos com tecnologia moderna, métodos baseados em evidências científicas e uma equipe qualificada, que prioriza o atendimento humanizado, ético e responsável. Cada paciente é acolhido de forma única, com atenção à sua história, às suas queixas e aos seus objetivos.

                        Na NeuroAudio, entendemos que ouvir bem e ter um bom equilíbrio é essencial para o desenvolvimento, a interação social, a aprendizagem e a qualidade de vida. Por isso, trabalhamos para promover não apenas a melhora auditiva, mas também o bem-estar e a autonomia de nossos pacientes.

                        Aqui, ciência e cuidado caminham juntos para oferecer um atendimento completo e de excelência.
                    </p>
                </div>
                <div className={`${css.carrosselIn} bg-white`}>
                    <Swiper
                        className={"h-100"}
                        modules={[Pagination, Autoplay]}
                        spaceBetween={50}
                        slidesPerView={1}
                        pagination={{ clickable: true }}

                        autoplay={{
                            delay: 4000, // 4 segundos
                            disableOnInteraction: false // continua mesmo se o usuário interagir
                        }}
                    >
                        <SwiperSlide className={"d-flex justify-content-center align-items-center"}>
                            <img className={css.imgCarrossel} src="/cr3.webp" alt="" />
                        </SwiperSlide>
                        <SwiperSlide className={"d-flex justify-content-center align-items-center"}>
                            <img className={css.imgCarrossel} src="/cr1.webp" alt="" />
                        </SwiperSlide>
                        <SwiperSlide className={"d-flex justify-content-center align-items-center"}>
                            <img className={css.imgCarrossel} src="/cr4.webp" alt="" />
                        </SwiperSlide>
                        <SwiperSlide className={"d-flex justify-content-center align-items-center"}>
                            <img className={css.imgCarrossel} src="/cr2.webp" alt="" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default Carrossel;
